import { findCountryName } from "@redotech/locale/countries";
import { shopifyProvinces } from "@redotech/locale/provinces";
import { parseCountryColumn } from "@redotech/redo-fulfillment-rate-table-common/rate-table";

export function provinceName(country: string, province: string): string {
  return (
    shopifyProvinces.find(
      (p) => p.countryCode === country && p.provinceCode === province,
    )?.province ?? province
  );
}

export function countryColumnLabel(column: string): string {
  const { country, province } = parseCountryColumn(column);
  const countryName = findCountryName(country) ?? country;
  return province
    ? `${countryName} — ${provinceName(country, province)}`
    : countryName;
}
